import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { NotificationService } from '../service/notification.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

const READ: string = "READ";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  accountCategory: string = '';
  notifications: Array<any> = [];
  notificationMasterData: Array<any> = [];
  selectedNotifications: Array<any> = [];
  notificationStatus = ["READ", "UNREAD"];
  notificationActionStatus = ["UNRESOLVED", "RESOLVED"]; //, "EXPIRED"

  confirmationModalAttributes: any;
  notificationFilters: any;

  markAsReadBtn: any = new ButtonParams('MARK AS READ', (notification) => this.onMarkAsRead(notification));
  viewInvoiceBtn: any = new ButtonParams('VIEW INVOICE', (notification) => this.handleViewInvoice(notification));
  markAsResolvedBtn: any = new ButtonParams('MARK AS RESOLVED', (notification) => this.onMarkAsResolved(notification));

  moduleEventMapping: Map<string, ModuleActionMap> = new Map<string, ModuleActionMap>([
    ['BILLING', this.getBillingModuleActionMap()]
  ]);

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService,
    private toastService: ToastService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.getNotifications();
    this.initConfirmationModalAttributes();
    this.initNotificationFilters();
  }

  initConfirmationModalAttributes() {
    this.confirmationModalAttributes = {
      "modalId": "deleteNotifications",
      "modalOpenButtonId": "openDeleteNotifications",
      "modalCloseButtonId": "closeDeleteNotifications",
      "modalHeader": "Delete Notification(s)",
      "content": "Confirm deleting selected notification(s)?"
    }
  }

  initNotificationFilters() {
    this.notificationFilters = {
      "status": null,
      "actionStatus": null
    }
  }

  isFilterApplied(): boolean {
    if(this.notificationFilters.status || this.notificationFilters.actionStatus) return true;
    return false;
  }

  getNotifications() {
    this.utilService.showSpinner();
    this.apiService.getWebNotifications().then((data) => {
      console.log("notifications: ", data);
      this.notifications = data;
      this.setNotificationButtons();
      this.utilService.hideSpinner();
      this.notificationMasterData = this.notifications.map(x => Object.assign({}, x));
      this.applyLocalFilters();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.getNotifications();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  setNotificationButtons() {
    if(!this.notifications || this.notifications.length == 0) return;
    this.notifications.forEach(notification => {
      let buttons = this.getNotificationButtons(notification);
      notification['buttons'] = buttons;
    });
  }

  getWebNotificationsByStatus(status: string) {
    this.utilService.showSpinner();
    this.apiService.getWebNotificationsByStatus(status).then((data) => {
      console.log("notifications: ", data);
      this.notifications = data;
      this.setNotificationButtons();
      this.utilService.hideSpinner();
      this.notificationMasterData = this.notifications.map(x => Object.assign({}, x));
      this.applyLocalFilters();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.getWebNotificationsByStatus(status);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getNotificationButtons(notification): any[] {
    let module = notification.notificationMessage.module;
    let event = notification.notificationMessage.event;

    let buttons = [];

    if(module && this.moduleEventMapping.has(module)) {
      let moduleActionMap: ModuleActionMap = this.moduleEventMapping.get(module);
      if(moduleActionMap.buttons && moduleActionMap.buttons.length > 0) {
        buttons = moduleActionMap.buttons.map(x => Object.assign({}, x));
      } else if(event && moduleActionMap.events && moduleActionMap.events.has(event)) {
        let eventActions: ButtonParams[] = moduleActionMap.events.get(event);
        buttons = eventActions ? eventActions.map(x => Object.assign({}, x)) : [];
      }
    }

    // Remove MARK AS READ button if notification is READ
    if(notification.status == 'READ') {
      this.removeButton(buttons,'MARK AS READ');
    }

    // Remove MARK AS RESOLVED button if notification is RESOLVED
    if(notification.notificationMessage.actionStatus == 'RESOLVED') {
      this.removeButton(buttons,'MARK AS RESOLVED');
    }

    return buttons;
  }

  private removeButton(buttons: ButtonParams[], label: string) {
    var index = buttons.findIndex(button => button.label == label);
    if (index >= 0) {
      buttons.splice(index, 1);
    }
  }

  updateNotification(requestPayload) {
    this.utilService.showSpinner();
    this.apiService.updateWebNotification(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("notification update response: ", data);
      this.resetNotificationSelection();
      this.getNotifications();
      this.notificationService.notificationUpdated.next();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.updateNotification(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateNotificationActionStatus(requestPayload) {
    this.utilService.showSpinner();
    this.apiService.updateWebNotificationActionStatus(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("notification action status update response: ", data);
      this.getNotifications();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.updateNotificationActionStatus(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onMarkAsRead(notification: any) {
    console.log("mark as read::", notification);
    if(notification.status == READ) return;
    var requestPayload = {
      "isDeleted": false,
      "notificationIds": [notification.id],
      "status": "READ"
    }
    this.updateNotification(requestPayload);
  }

  onDeleteNotification() {
    // console.log("delete notifications::", this.selectedNotifications);
    var notificationIds = this.selectedNotifications.map(({ id }) => id);
    var requestPayload = {
      "isDeleted": true,
      "notificationIds": notificationIds
    }
    // console.log("final payload for deletion", requestPayload);
    this.updateNotification(requestPayload);
  }

  onDeleteNotifications() {
    console.log("final selected service list : ", this.selectedNotifications);
    document.getElementById(this.confirmationModalAttributes.modalOpenButtonId).click();
  }

  onNotificationSelected(checked, notification) {
    var notificationIndex = this.selectedNotifications.findIndex(v => v.id === notification.id);

    if (checked && notificationIndex == -1) {
      this.selectedNotifications.push(notification);
    } else if (!checked && notificationIndex >= 0) {
      this.selectedNotifications.splice(notificationIndex, 1);
    }
  }

  isPreSelected(notification) {
    return this.selectedNotifications.some(selectedNotification => selectedNotification.id === notification.id);
  }

  handleViewInvoice(notification: any) {
    this.onMarkAsRead(notification);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "id": notification.notificationMessage.objectId
      }
    };
    // console.log("navigation extras", navigationExtras)
    this.router.navigate(["/invoices"], navigationExtras);
  }

  onMarkAsResolved(notification: any) {
    console.log("mark as resolved notification::", notification);
    this.onMarkAsRead(notification);
    var requestPayload = {
      "actionStatus": "RESOLVED",
      "notificationMessageIds": [notification.notificationMessage.id]
    }
    this.updateNotificationActionStatus(requestPayload);
  }

  // Confirmation event handling

  onConfirm(data?) {
    console.log("on confirm clicked.");
    this.onDeleteNotification();
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
  }

  onConfirmCancel(data?) {
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
    this.resetNotificationSelection();
  }

  resetNotificationSelection() {
    this.selectedNotifications = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  // Handle Filters

  applyLocalFilters() {
    if(this.notificationFilters.actionStatus) {
      this.onNotificationActionStatusChange();
    }
  }

  onNotificationStatusChange() {
    if (isNullOrUndefined(this.notificationFilters.status)) {
      this.getNotifications();
    } else {
      this.getWebNotificationsByStatus(this.notificationFilters.status);
    }
  }

  onNotificationActionStatusChange() {
    if (isNullOrUndefined(this.notificationFilters.actionStatus)) {
      this.notifications = this.notificationMasterData;
    } else {
      this.notifications = this.notificationMasterData.filter(notification => notification.notificationMessage.actionStatus == this.notificationFilters.actionStatus);
    }
  }

  getBillingModuleActionMap(): ModuleActionMap {
    return new ModuleActionMap(
      new Map<string, Array<ButtonParams>>([
        [
          'INVOICE_PUBLISHED',
          [this.viewInvoiceBtn, this.markAsReadBtn]
        ], [
          'PAYMENT_DUE_NOTIFICATION',
          [this.markAsResolvedBtn, this.viewInvoiceBtn]
        ], [
          'PAYMENT_SUCCESS', 
          [this.viewInvoiceBtn, this.markAsReadBtn]
        ], [
          'PAYMENT_FAILED',
          [this.viewInvoiceBtn, this.markAsReadBtn]
        ]
      ]),
      []
    )
  }

}


export class ModuleActionMap {
  constructor(
    public events: Map<string, Array<ButtonParams>>,
    public buttons: Array<ButtonParams>
  ) { }
}

export class ButtonParams {
  constructor(
    public label: string,
    public action: any
  ) { }
}